<script>
export default {
};
</script>

<template lang="pug" functional>
functional-binder(:data-object="data")
  arrow-style(v-bind="props")
    button.arrow-button-pa(type="button")
      icon.fill-inherit(style="width:4rem;" name="arrow")
</template>

<style>
.arrow-button-pa {
  padding: 0rem;
}
</style>
